import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Card, CardContent, Container, Typography, Box, CircularProgress } from "@mui/material";
import SumsubWebSdk from "@sumsub/websdk-react";

const SumsubKyc = () => {
  const [accessToken, setAccessToken] = useState(null);
  const userEmail = Cookies.get("email") || null; // Get user's email from session storage

  // Fetch the access token from your backend
  useEffect(() => {
    const fetchAccessToken = async () => {
      try {
        const response = await fetch("/api/getAccessToken", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: userEmail }), // Send user's email in the request body
        });

        const data = await response.json();
        if (data.token) {
          setAccessToken(data.token);
        } else {
          console.error("Failed to fetch Sumsub access token");
        }
      } catch (error) {
        console.error("Error fetching Sumsub access token:", error);
      }
    };

    if (userEmail) {
      fetchAccessToken();
    } else {
      console.error("User email not found in session storage");
    }
  }, [userEmail]);

  // Handle token expiration
  const handleTokenExpiration = (resolve) => {
    fetch("/api/getAccessToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: userEmail }), // Send user's email in the request body
    })
      .then((res) => res.json())
      .then((data) => resolve(data.token))
      .catch((err) => console.error("Error refreshing token:", err));
  };

  // Handle messages from the SDK
  const handleMessage = (type, payload) => {
    //console.log("Sumsub SDK message:", type, payload);
  };

  // Handle errors from the SDK
  const handleError = (error) => {
    console.error("Sumsub SDK error:", error);
  };

  return (
    <Container maxWidth="sm" sx={{ backgroundColor: "#f5f5f5", mt: 4 }}>
      <Card sx={{ borderRadius: 4, boxShadow: 0 }}>
        <CardContent>
          {/* Text */}
          <Typography variant="body1" fontWeight="bold" align="center" sx={{ mb: 2 }}>
            Verify your KYC identity
          </Typography>
          {/* Sumsub Web SDK */}
          {accessToken ? (
            <SumsubWebSdk
              accessToken={accessToken}
              expirationHandler={handleTokenExpiration}
              onMessage={handleMessage}
              config={{
                lang: "en",
                email: userEmail,
              }}
              onError={handleError}
            />
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
              <CircularProgress color="primary" />
            </Box>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default SumsubKyc;